import { Column, Columns } from '@dixa/lib-shared-habla';

import { ShopifyCards } from 'components/settings/components/sections/cards';

export const SettingsIntegrationsCardsShopifyEditView = (): JSX.Element => {
  return (
    <Columns>
      <Column>
        <ShopifyCards mode="edit" />
      </Column>
    </Columns>
  );
};
